/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  BeverageCategories,
  BeverageCategory,
  BeverageCategoryChoice,
  BeverageMovementWritten,
  BeverageProduct,
  BeverageReceipt,
  BeverageReceiptWritten,
  BeverageStockItem,
  BeverageStockSummary,
  GetBeverageStockSummaryParams,
  GetReorderDraftsParams,
  GetStockItemsParams,
  GetStockMovementsParams,
  GetSuppliersParams,
  PatchSupplierItemsIdBody,
  PatchSuppliersIdBody,
  PostBeverageStockMovementBody,
  PostStockReceiptsBody,
  PostStockReceiptsOcrBody,
  PostSuppliersBody,
  PostSuppliersSupplierIdItemsBody,
  PutReorderDraftsIdLinesBody,
  ReceiptOcrResult,
  ReorderAutoGenerateResult,
  ReorderDraft,
  ReorderDraftSummary,
  ResolvedSupplierCode,
  StockCategory,
  StockCategoryRequest,
  StockItem,
  StockItemRequest,
  StockMargin,
  StockMovementPage,
  StockMovementRequest,
  StockMovementWritten,
  StockReceiptCreated,
  Supplier,
  SupplierBackfillResult,
  SupplierCodeWritten,
  SupplierComparison,
  SupplierItemCode,
  SupplierPriceHistoryEntry,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getPutReorderDraftsIdLinesUrl = (id: number) => {
  return `/api/v1/reorder-drafts/${id}/lines`
}

/**
 * @summary Replace a draft's lines
 */
export const putReorderDraftsIdLines = async (
  id: number,
  putReorderDraftsIdLinesBody?: PutReorderDraftsIdLinesBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getPutReorderDraftsIdLinesUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putReorderDraftsIdLinesBody),
  })
}

export const getPutReorderDraftsIdLinesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putReorderDraftsIdLines>>,
    TError,
    { id: number; data?: PutReorderDraftsIdLinesBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putReorderDraftsIdLines>>,
  TError,
  { id: number; data?: PutReorderDraftsIdLinesBody },
  TContext
> => {
  const mutationKey = ['putReorderDraftsIdLines']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putReorderDraftsIdLines>>,
    { id: number; data?: PutReorderDraftsIdLinesBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return putReorderDraftsIdLines(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutReorderDraftsIdLinesMutationResult = NonNullable<
  Awaited<ReturnType<typeof putReorderDraftsIdLines>>
>
export type PutReorderDraftsIdLinesMutationBody = PutReorderDraftsIdLinesBody | undefined
export type PutReorderDraftsIdLinesMutationError = unknown

/**
 * @summary Replace a draft's lines
 */
export const usePutReorderDraftsIdLines = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putReorderDraftsIdLines>>,
      TError,
      { id: number; data?: PutReorderDraftsIdLinesBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putReorderDraftsIdLines>>,
  TError,
  { id: number; data?: PutReorderDraftsIdLinesBody },
  TContext
> => {
  return useMutation(getPutReorderDraftsIdLinesMutationOptions(options), queryClient)
}
export const getPutBeverageStockStockCategoriesIdUrl = (id: number) => {
  return `/api/v1/beverage-stock/stock-categories/${id}`
}

/**
 * @summary Decide whether a stock category's items are drinks, and in which tab
 */
export const putBeverageStockStockCategoriesId = async (
  id: number,
  beverageCategoryChoice: BeverageCategoryChoice,
  options?: Parameters<typeof customFetch>[1],
): Promise<BeverageCategory> => {
  return customFetch<BeverageCategory>(getPutBeverageStockStockCategoriesIdUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(beverageCategoryChoice),
  })
}

export const getPutBeverageStockStockCategoriesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBeverageStockStockCategoriesId>>,
    TError,
    { id: number; data: BeverageCategoryChoice },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBeverageStockStockCategoriesId>>,
  TError,
  { id: number; data: BeverageCategoryChoice },
  TContext
> => {
  const mutationKey = ['putBeverageStockStockCategoriesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBeverageStockStockCategoriesId>>,
    { id: number; data: BeverageCategoryChoice }
  > = (props) => {
    const { id, data } = props ?? {}

    return putBeverageStockStockCategoriesId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutBeverageStockStockCategoriesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putBeverageStockStockCategoriesId>>
>
export type PutBeverageStockStockCategoriesIdMutationBody = BeverageCategoryChoice
export type PutBeverageStockStockCategoriesIdMutationError = unknown

/**
 * @summary Decide whether a stock category's items are drinks, and in which tab
 */
export const usePutBeverageStockStockCategoriesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putBeverageStockStockCategoriesId>>,
      TError,
      { id: number; data: BeverageCategoryChoice },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putBeverageStockStockCategoriesId>>,
  TError,
  { id: number; data: BeverageCategoryChoice },
  TContext
> => {
  return useMutation(getPutBeverageStockStockCategoriesIdMutationOptions(options), queryClient)
}
export const getPutBeverageStockProductCategoriesIdUrl = (id: number) => {
  return `/api/v1/beverage-stock/product-categories/${id}`
}

/**
 * @summary Decide whether the bar may receive a product category's products
 */
export const putBeverageStockProductCategoriesId = async (
  id: number,
  beverageCategoryChoice: BeverageCategoryChoice,
  options?: Parameters<typeof customFetch>[1],
): Promise<BeverageCategory> => {
  return customFetch<BeverageCategory>(getPutBeverageStockProductCategoriesIdUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(beverageCategoryChoice),
  })
}

export const getPutBeverageStockProductCategoriesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBeverageStockProductCategoriesId>>,
    TError,
    { id: number; data: BeverageCategoryChoice },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBeverageStockProductCategoriesId>>,
  TError,
  { id: number; data: BeverageCategoryChoice },
  TContext
> => {
  const mutationKey = ['putBeverageStockProductCategoriesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBeverageStockProductCategoriesId>>,
    { id: number; data: BeverageCategoryChoice }
  > = (props) => {
    const { id, data } = props ?? {}

    return putBeverageStockProductCategoriesId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutBeverageStockProductCategoriesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putBeverageStockProductCategoriesId>>
>
export type PutBeverageStockProductCategoriesIdMutationBody = BeverageCategoryChoice
export type PutBeverageStockProductCategoriesIdMutationError = unknown

/**
 * @summary Decide whether the bar may receive a product category's products
 */
export const usePutBeverageStockProductCategoriesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putBeverageStockProductCategoriesId>>,
      TError,
      { id: number; data: BeverageCategoryChoice },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putBeverageStockProductCategoriesId>>,
  TError,
  { id: number; data: BeverageCategoryChoice },
  TContext
> => {
  return useMutation(getPutBeverageStockProductCategoriesIdMutationOptions(options), queryClient)
}
export const getGetSuppliersUrl = (params?: GetSuppliersParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/suppliers?${stringifiedParams}`
    : `/api/v1/suppliers`
}

/**
 * @summary Who the restaurant buys from
 */
export const getSuppliers = async (
  params?: GetSuppliersParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Supplier[]> => {
  return customFetch<Supplier[]>(getGetSuppliersUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuppliersQueryKey = (params?: GetSuppliersParams) => {
  return [`/api/v1/suppliers`, ...(params ? [params] : [])] as const
}

export const getGetSuppliersQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuppliers>>,
  TError = unknown,
>(
  params?: GetSuppliersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuppliers>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuppliersQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuppliers>>> = ({ signal }) =>
    getSuppliers(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuppliers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuppliersQueryResult = NonNullable<Awaited<ReturnType<typeof getSuppliers>>>
export type GetSuppliersQueryError = unknown

export function useGetSuppliers<TData = Awaited<ReturnType<typeof getSuppliers>>, TError = unknown>(
  params: undefined | GetSuppliersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuppliers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuppliers>>,
          TError,
          Awaited<ReturnType<typeof getSuppliers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuppliers<TData = Awaited<ReturnType<typeof getSuppliers>>, TError = unknown>(
  params?: GetSuppliersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuppliers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuppliers>>,
          TError,
          Awaited<ReturnType<typeof getSuppliers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuppliers<TData = Awaited<ReturnType<typeof getSuppliers>>, TError = unknown>(
  params?: GetSuppliersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuppliers>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Who the restaurant buys from
 */

export function useGetSuppliers<TData = Awaited<ReturnType<typeof getSuppliers>>, TError = unknown>(
  params?: GetSuppliersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuppliers>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuppliersQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSuppliersUrl = () => {
  return `/api/v1/suppliers`
}

/**
 * @summary Add a supplier
 */
export const postSuppliers = async (
  postSuppliersBody?: PostSuppliersBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Supplier> => {
  return customFetch<Supplier>(getPostSuppliersUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSuppliersBody),
  })
}

export const getPostSuppliersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuppliers>>,
    TError,
    { data?: PostSuppliersBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuppliers>>,
  TError,
  { data?: PostSuppliersBody },
  TContext
> => {
  const mutationKey = ['postSuppliers']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuppliers>>,
    { data?: PostSuppliersBody }
  > = (props) => {
    const { data } = props ?? {}

    return postSuppliers(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuppliersMutationResult = NonNullable<Awaited<ReturnType<typeof postSuppliers>>>
export type PostSuppliersMutationBody = PostSuppliersBody | undefined
export type PostSuppliersMutationError = unknown

/**
 * @summary Add a supplier
 */
export const usePostSuppliers = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuppliers>>,
      TError,
      { data?: PostSuppliersBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuppliers>>,
  TError,
  { data?: PostSuppliersBody },
  TContext
> => {
  return useMutation(getPostSuppliersMutationOptions(options), queryClient)
}
export const getGetSuppliersSupplierIdItemsUrl = (supplierId: number) => {
  return `/api/v1/suppliers/${supplierId}/items`
}

/**
 * @summary A supplier's own item codes
 */
export const getSuppliersSupplierIdItems = async (
  supplierId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierItemCode[]> => {
  return customFetch<SupplierItemCode[]>(getGetSuppliersSupplierIdItemsUrl(supplierId), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuppliersSupplierIdItemsQueryKey = (supplierId: number) => {
  return [`/api/v1/suppliers/${supplierId}/items`] as const
}

export const getGetSuppliersSupplierIdItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>,
  TError = unknown,
>(
  supplierId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuppliersSupplierIdItemsQueryKey(supplierId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>> = ({
    signal,
  }) => getSuppliersSupplierIdItems(supplierId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: supplierId !== null && supplierId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetSuppliersSupplierIdItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>
>
export type GetSuppliersSupplierIdItemsQueryError = unknown

export function useGetSuppliersSupplierIdItems<
  TData = Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>,
  TError = unknown,
>(
  supplierId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>,
          TError,
          Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuppliersSupplierIdItems<
  TData = Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>,
  TError = unknown,
>(
  supplierId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>,
          TError,
          Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuppliersSupplierIdItems<
  TData = Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>,
  TError = unknown,
>(
  supplierId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A supplier's own item codes
 */

export function useGetSuppliersSupplierIdItems<
  TData = Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>,
  TError = unknown,
>(
  supplierId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuppliersSupplierIdItems>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuppliersSupplierIdItemsQueryOptions(supplierId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSuppliersSupplierIdItemsUrl = (supplierId: number) => {
  return `/api/v1/suppliers/${supplierId}/items`
}

/**
 * @summary Map one of a supplier's codes to a stock item
 */
export const postSuppliersSupplierIdItems = async (
  supplierId: number,
  postSuppliersSupplierIdItemsBody?: PostSuppliersSupplierIdItemsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierCodeWritten> => {
  return customFetch<SupplierCodeWritten>(getPostSuppliersSupplierIdItemsUrl(supplierId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSuppliersSupplierIdItemsBody),
  })
}

export const getPostSuppliersSupplierIdItemsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuppliersSupplierIdItems>>,
    TError,
    { supplierId: number; data?: PostSuppliersSupplierIdItemsBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuppliersSupplierIdItems>>,
  TError,
  { supplierId: number; data?: PostSuppliersSupplierIdItemsBody },
  TContext
> => {
  const mutationKey = ['postSuppliersSupplierIdItems']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuppliersSupplierIdItems>>,
    { supplierId: number; data?: PostSuppliersSupplierIdItemsBody }
  > = (props) => {
    const { supplierId, data } = props ?? {}

    return postSuppliersSupplierIdItems(supplierId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuppliersSupplierIdItemsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuppliersSupplierIdItems>>
>
export type PostSuppliersSupplierIdItemsMutationBody = PostSuppliersSupplierIdItemsBody | undefined
export type PostSuppliersSupplierIdItemsMutationError = unknown

/**
 * @summary Map one of a supplier's codes to a stock item
 */
export const usePostSuppliersSupplierIdItems = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuppliersSupplierIdItems>>,
      TError,
      { supplierId: number; data?: PostSuppliersSupplierIdItemsBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuppliersSupplierIdItems>>,
  TError,
  { supplierId: number; data?: PostSuppliersSupplierIdItemsBody },
  TContext
> => {
  return useMutation(getPostSuppliersSupplierIdItemsMutationOptions(options), queryClient)
}
export const getPostSuppliersBackfillFromReceiptsUrl = () => {
  return `/api/v1/suppliers/backfill-from-receipts`
}

/**
 * @summary Make supplier records from the names on old receipts
 */
export const postSuppliersBackfillFromReceipts = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierBackfillResult> => {
  return customFetch<SupplierBackfillResult>(getPostSuppliersBackfillFromReceiptsUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostSuppliersBackfillFromReceiptsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuppliersBackfillFromReceipts>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuppliersBackfillFromReceipts>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postSuppliersBackfillFromReceipts']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuppliersBackfillFromReceipts>>,
    void
  > = () => {
    return postSuppliersBackfillFromReceipts(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuppliersBackfillFromReceiptsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuppliersBackfillFromReceipts>>
>

export type PostSuppliersBackfillFromReceiptsMutationError = unknown

/**
 * @summary Make supplier records from the names on old receipts
 */
export const usePostSuppliersBackfillFromReceipts = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuppliersBackfillFromReceipts>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuppliersBackfillFromReceipts>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostSuppliersBackfillFromReceiptsMutationOptions(options), queryClient)
}
export const getPostStockReceiptsUrl = () => {
  return `/api/v1/stock/receipts`
}

/**
 * @summary Record a delivery
 */
export const postStockReceipts = async (
  postStockReceiptsBody?: PostStockReceiptsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<StockReceiptCreated> => {
  return customFetch<StockReceiptCreated>(getPostStockReceiptsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postStockReceiptsBody),
  })
}

export const getPostStockReceiptsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStockReceipts>>,
    TError,
    { data?: PostStockReceiptsBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postStockReceipts>>,
  TError,
  { data?: PostStockReceiptsBody },
  TContext
> => {
  const mutationKey = ['postStockReceipts']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postStockReceipts>>,
    { data?: PostStockReceiptsBody }
  > = (props) => {
    const { data } = props ?? {}

    return postStockReceipts(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostStockReceiptsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postStockReceipts>>
>
export type PostStockReceiptsMutationBody = PostStockReceiptsBody | undefined
export type PostStockReceiptsMutationError = unknown

/**
 * @summary Record a delivery
 */
export const usePostStockReceipts = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postStockReceipts>>,
      TError,
      { data?: PostStockReceiptsBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postStockReceipts>>,
  TError,
  { data?: PostStockReceiptsBody },
  TContext
> => {
  return useMutation(getPostStockReceiptsMutationOptions(options), queryClient)
}
export const getPostStockReceiptsOcrUrl = () => {
  return `/api/v1/stock/receipts/ocr`
}

/**
 * @summary Read a delivery note from a photograph
 */
export const postStockReceiptsOcr = async (
  postStockReceiptsOcrBody?: PostStockReceiptsOcrBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReceiptOcrResult> => {
  return customFetch<ReceiptOcrResult>(getPostStockReceiptsOcrUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postStockReceiptsOcrBody),
  })
}

export const getPostStockReceiptsOcrMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStockReceiptsOcr>>,
    TError,
    { data?: PostStockReceiptsOcrBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postStockReceiptsOcr>>,
  TError,
  { data?: PostStockReceiptsOcrBody },
  TContext
> => {
  const mutationKey = ['postStockReceiptsOcr']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postStockReceiptsOcr>>,
    { data?: PostStockReceiptsOcrBody }
  > = (props) => {
    const { data } = props ?? {}

    return postStockReceiptsOcr(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostStockReceiptsOcrMutationResult = NonNullable<
  Awaited<ReturnType<typeof postStockReceiptsOcr>>
>
export type PostStockReceiptsOcrMutationBody = PostStockReceiptsOcrBody | undefined
export type PostStockReceiptsOcrMutationError = unknown

/**
 * @summary Read a delivery note from a photograph
 */
export const usePostStockReceiptsOcr = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postStockReceiptsOcr>>,
      TError,
      { data?: PostStockReceiptsOcrBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postStockReceiptsOcr>>,
  TError,
  { data?: PostStockReceiptsOcrBody },
  TContext
> => {
  return useMutation(getPostStockReceiptsOcrMutationOptions(options), queryClient)
}
export const getGetStockMovementsUrl = (params?: GetStockMovementsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/stock/movements?${stringifiedParams}`
    : `/api/v1/stock/movements`
}

/**
 * @summary Why the quantities changed
 */
export const getStockMovements = async (
  params?: GetStockMovementsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<StockMovementPage> => {
  return customFetch<StockMovementPage>(getGetStockMovementsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetStockMovementsQueryKey = (params?: GetStockMovementsParams) => {
  return [`/api/v1/stock/movements`, ...(params ? [params] : [])] as const
}

export const getGetStockMovementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockMovements>>,
  TError = unknown,
>(
  params?: GetStockMovementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockMovements>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetStockMovementsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockMovements>>> = ({ signal }) =>
    getStockMovements(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockMovements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStockMovementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockMovements>>
>
export type GetStockMovementsQueryError = unknown

export function useGetStockMovements<
  TData = Awaited<ReturnType<typeof getStockMovements>>,
  TError = unknown,
>(
  params: undefined | GetStockMovementsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockMovements>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockMovements>>,
          TError,
          Awaited<ReturnType<typeof getStockMovements>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockMovements<
  TData = Awaited<ReturnType<typeof getStockMovements>>,
  TError = unknown,
>(
  params?: GetStockMovementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockMovements>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockMovements>>,
          TError,
          Awaited<ReturnType<typeof getStockMovements>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockMovements<
  TData = Awaited<ReturnType<typeof getStockMovements>>,
  TError = unknown,
>(
  params?: GetStockMovementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockMovements>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Why the quantities changed
 */

export function useGetStockMovements<
  TData = Awaited<ReturnType<typeof getStockMovements>>,
  TError = unknown,
>(
  params?: GetStockMovementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockMovements>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStockMovementsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostStockMovementsUrl = () => {
  return `/api/v1/stock/movements`
}

/**
 * @summary Move stock
 */
export const postStockMovements = async (
  stockMovementRequest?: StockMovementRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<StockMovementWritten> => {
  return customFetch<StockMovementWritten>(getPostStockMovementsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stockMovementRequest),
  })
}

export const getPostStockMovementsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStockMovements>>,
    TError,
    { data?: StockMovementRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postStockMovements>>,
  TError,
  { data?: StockMovementRequest },
  TContext
> => {
  const mutationKey = ['postStockMovements']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postStockMovements>>,
    { data?: StockMovementRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postStockMovements(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostStockMovementsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postStockMovements>>
>
export type PostStockMovementsMutationBody = StockMovementRequest | undefined
export type PostStockMovementsMutationError = unknown

/**
 * @summary Move stock
 */
export const usePostStockMovements = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postStockMovements>>,
      TError,
      { data?: StockMovementRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postStockMovements>>,
  TError,
  { data?: StockMovementRequest },
  TContext
> => {
  return useMutation(getPostStockMovementsMutationOptions(options), queryClient)
}
export const getGetStockItemsUrl = (params?: GetStockItemsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/stock/items?${stringifiedParams}`
    : `/api/v1/stock/items`
}

/**
 * @summary What is on the shelves
 */
export const getStockItems = async (
  params?: GetStockItemsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<StockItem[]> => {
  return customFetch<StockItem[]>(getGetStockItemsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetStockItemsQueryKey = (params?: GetStockItemsParams) => {
  return [`/api/v1/stock/items`, ...(params ? [params] : [])] as const
}

export const getGetStockItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockItems>>,
  TError = unknown,
>(
  params?: GetStockItemsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockItems>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetStockItemsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockItems>>> = ({ signal }) =>
    getStockItems(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStockItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getStockItems>>>
export type GetStockItemsQueryError = unknown

export function useGetStockItems<
  TData = Awaited<ReturnType<typeof getStockItems>>,
  TError = unknown,
>(
  params: undefined | GetStockItemsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockItems>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockItems>>,
          TError,
          Awaited<ReturnType<typeof getStockItems>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockItems<
  TData = Awaited<ReturnType<typeof getStockItems>>,
  TError = unknown,
>(
  params?: GetStockItemsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockItems>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockItems>>,
          TError,
          Awaited<ReturnType<typeof getStockItems>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockItems<
  TData = Awaited<ReturnType<typeof getStockItems>>,
  TError = unknown,
>(
  params?: GetStockItemsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockItems>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What is on the shelves
 */

export function useGetStockItems<
  TData = Awaited<ReturnType<typeof getStockItems>>,
  TError = unknown,
>(
  params?: GetStockItemsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockItems>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStockItemsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostStockItemsUrl = () => {
  return `/api/v1/stock/items`
}

/**
 * @summary Add a stock item
 */
export const postStockItems = async (
  stockItemRequest?: StockItemRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<StockItem> => {
  return customFetch<StockItem>(getPostStockItemsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stockItemRequest),
  })
}

export const getPostStockItemsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStockItems>>,
    TError,
    { data?: StockItemRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postStockItems>>,
  TError,
  { data?: StockItemRequest },
  TContext
> => {
  const mutationKey = ['postStockItems']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postStockItems>>,
    { data?: StockItemRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postStockItems(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostStockItemsMutationResult = NonNullable<Awaited<ReturnType<typeof postStockItems>>>
export type PostStockItemsMutationBody = StockItemRequest | undefined
export type PostStockItemsMutationError = unknown

/**
 * @summary Add a stock item
 */
export const usePostStockItems = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postStockItems>>,
      TError,
      { data?: StockItemRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postStockItems>>,
  TError,
  { data?: StockItemRequest },
  TContext
> => {
  return useMutation(getPostStockItemsMutationOptions(options), queryClient)
}
export const getGetStockItemCategoriesUrl = () => {
  return `/api/v1/stock-item-categories`
}

/**
 * @summary The stock categories, as rows
 */
export const getStockItemCategories = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<StockCategory[]> => {
  return customFetch<StockCategory[]>(getGetStockItemCategoriesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetStockItemCategoriesQueryKey = () => {
  return [`/api/v1/stock-item-categories`] as const
}

export const getGetStockItemCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockItemCategories>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getStockItemCategories>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetStockItemCategoriesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockItemCategories>>> = ({ signal }) =>
    getStockItemCategories({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockItemCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStockItemCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockItemCategories>>
>
export type GetStockItemCategoriesQueryError = unknown

export function useGetStockItemCategories<
  TData = Awaited<ReturnType<typeof getStockItemCategories>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockItemCategories>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockItemCategories>>,
          TError,
          Awaited<ReturnType<typeof getStockItemCategories>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockItemCategories<
  TData = Awaited<ReturnType<typeof getStockItemCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockItemCategories>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockItemCategories>>,
          TError,
          Awaited<ReturnType<typeof getStockItemCategories>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockItemCategories<
  TData = Awaited<ReturnType<typeof getStockItemCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockItemCategories>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The stock categories, as rows
 */

export function useGetStockItemCategories<
  TData = Awaited<ReturnType<typeof getStockItemCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockItemCategories>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStockItemCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostStockItemCategoriesUrl = () => {
  return `/api/v1/stock-item-categories`
}

/**
 * @summary Add a stock category
 */
export const postStockItemCategories = async (
  stockCategoryRequest: StockCategoryRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<StockCategory> => {
  return customFetch<StockCategory>(getPostStockItemCategoriesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stockCategoryRequest),
  })
}

export const getPostStockItemCategoriesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStockItemCategories>>,
    TError,
    { data: StockCategoryRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postStockItemCategories>>,
  TError,
  { data: StockCategoryRequest },
  TContext
> => {
  const mutationKey = ['postStockItemCategories']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postStockItemCategories>>,
    { data: StockCategoryRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postStockItemCategories(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostStockItemCategoriesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postStockItemCategories>>
>
export type PostStockItemCategoriesMutationBody = StockCategoryRequest
export type PostStockItemCategoriesMutationError = unknown

/**
 * @summary Add a stock category
 */
export const usePostStockItemCategories = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postStockItemCategories>>,
      TError,
      { data: StockCategoryRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postStockItemCategories>>,
  TError,
  { data: StockCategoryRequest },
  TContext
> => {
  return useMutation(getPostStockItemCategoriesMutationOptions(options), queryClient)
}
export const getPostReorderDraftsIdMarkSentUrl = (id: number) => {
  return `/api/v1/reorder-drafts/${id}/mark-sent`
}

/**
 * @summary Record that a draft was ordered
 */
export const postReorderDraftsIdMarkSent = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getPostReorderDraftsIdMarkSentUrl(id), {
    ...options,
    method: 'POST',
  })
}

export const getPostReorderDraftsIdMarkSentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postReorderDraftsIdMarkSent>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postReorderDraftsIdMarkSent>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['postReorderDraftsIdMarkSent']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postReorderDraftsIdMarkSent>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return postReorderDraftsIdMarkSent(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostReorderDraftsIdMarkSentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postReorderDraftsIdMarkSent>>
>

export type PostReorderDraftsIdMarkSentMutationError = unknown

/**
 * @summary Record that a draft was ordered
 */
export const usePostReorderDraftsIdMarkSent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postReorderDraftsIdMarkSent>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postReorderDraftsIdMarkSent>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPostReorderDraftsIdMarkSentMutationOptions(options), queryClient)
}
export const getPostReorderDraftsAutoGenerateUrl = () => {
  return `/api/v1/reorder-drafts/auto-generate`
}

/**
 * @summary Draft purchase orders from what ran low
 */
export const postReorderDraftsAutoGenerate = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ReorderAutoGenerateResult> => {
  return customFetch<ReorderAutoGenerateResult>(getPostReorderDraftsAutoGenerateUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostReorderDraftsAutoGenerateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postReorderDraftsAutoGenerate>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postReorderDraftsAutoGenerate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postReorderDraftsAutoGenerate']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postReorderDraftsAutoGenerate>>,
    void
  > = () => {
    return postReorderDraftsAutoGenerate(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostReorderDraftsAutoGenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postReorderDraftsAutoGenerate>>
>

export type PostReorderDraftsAutoGenerateMutationError = unknown

/**
 * @summary Draft purchase orders from what ran low
 */
export const usePostReorderDraftsAutoGenerate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postReorderDraftsAutoGenerate>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postReorderDraftsAutoGenerate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostReorderDraftsAutoGenerateMutationOptions(options), queryClient)
}
export const getPostBeverageStockReceiptsUrl = () => {
  return `/api/v1/beverage-stock/receipts`
}

/**
 * @summary Receive a drink onto its own stock
 */
export const postBeverageStockReceipts = async (
  beverageReceipt: BeverageReceipt,
  options?: Parameters<typeof customFetch>[1],
): Promise<BeverageReceiptWritten> => {
  return customFetch<BeverageReceiptWritten>(getPostBeverageStockReceiptsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(beverageReceipt),
  })
}

export const getPostBeverageStockReceiptsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBeverageStockReceipts>>,
    TError,
    { data: BeverageReceipt },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBeverageStockReceipts>>,
  TError,
  { data: BeverageReceipt },
  TContext
> => {
  const mutationKey = ['postBeverageStockReceipts']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBeverageStockReceipts>>,
    { data: BeverageReceipt }
  > = (props) => {
    const { data } = props ?? {}

    return postBeverageStockReceipts(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostBeverageStockReceiptsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBeverageStockReceipts>>
>
export type PostBeverageStockReceiptsMutationBody = BeverageReceipt
export type PostBeverageStockReceiptsMutationError = unknown

/**
 * @summary Receive a drink onto its own stock
 */
export const usePostBeverageStockReceipts = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postBeverageStockReceipts>>,
      TError,
      { data: BeverageReceipt },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postBeverageStockReceipts>>,
  TError,
  { data: BeverageReceipt },
  TContext
> => {
  return useMutation(getPostBeverageStockReceiptsMutationOptions(options), queryClient)
}
export const getPostBeverageStockMovementUrl = () => {
  return `/api/v1/beverage-stock/movement`
}

/**
 * @summary Record a delivery to the bar
 */
export const postBeverageStockMovement = async (
  postBeverageStockMovementBody?: PostBeverageStockMovementBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<BeverageMovementWritten> => {
  return customFetch<BeverageMovementWritten>(getPostBeverageStockMovementUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postBeverageStockMovementBody),
  })
}

export const getPostBeverageStockMovementMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBeverageStockMovement>>,
    TError,
    { data?: PostBeverageStockMovementBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBeverageStockMovement>>,
  TError,
  { data?: PostBeverageStockMovementBody },
  TContext
> => {
  const mutationKey = ['postBeverageStockMovement']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBeverageStockMovement>>,
    { data?: PostBeverageStockMovementBody }
  > = (props) => {
    const { data } = props ?? {}

    return postBeverageStockMovement(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostBeverageStockMovementMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBeverageStockMovement>>
>
export type PostBeverageStockMovementMutationBody = PostBeverageStockMovementBody | undefined
export type PostBeverageStockMovementMutationError = unknown

/**
 * @summary Record a delivery to the bar
 */
export const usePostBeverageStockMovement = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postBeverageStockMovement>>,
      TError,
      { data?: PostBeverageStockMovementBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postBeverageStockMovement>>,
  TError,
  { data?: PostBeverageStockMovementBody },
  TContext
> => {
  return useMutation(getPostBeverageStockMovementMutationOptions(options), queryClient)
}
export const getGetSuppliersIdUrl = (id: number) => {
  return `/api/v1/suppliers/${id}`
}

/**
 * @summary One supplier
 */
export const getSuppliersId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<Supplier> => {
  return customFetch<Supplier>(getGetSuppliersIdUrl(id), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuppliersIdQueryKey = (id: number) => {
  return [`/api/v1/suppliers/${id}`] as const
}

export const getGetSuppliersIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuppliersId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuppliersId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuppliersIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuppliersId>>> = ({ signal }) =>
    getSuppliersId(id, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSuppliersId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetSuppliersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSuppliersId>>>
export type GetSuppliersIdQueryError = unknown

export function useGetSuppliersId<
  TData = Awaited<ReturnType<typeof getSuppliersId>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuppliersId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuppliersId>>,
          TError,
          Awaited<ReturnType<typeof getSuppliersId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuppliersId<
  TData = Awaited<ReturnType<typeof getSuppliersId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuppliersId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuppliersId>>,
          TError,
          Awaited<ReturnType<typeof getSuppliersId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuppliersId<
  TData = Awaited<ReturnType<typeof getSuppliersId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuppliersId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One supplier
 */

export function useGetSuppliersId<
  TData = Awaited<ReturnType<typeof getSuppliersId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuppliersId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuppliersIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getDeleteSuppliersIdUrl = (id: number) => {
  return `/api/v1/suppliers/${id}`
}

/**
 * @summary Remove a supplier
 */
export const deleteSuppliersId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteSuppliersIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteSuppliersIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSuppliersId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSuppliersId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteSuppliersId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSuppliersId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteSuppliersId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSuppliersIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSuppliersId>>
>

export type DeleteSuppliersIdMutationError = unknown

/**
 * @summary Remove a supplier
 */
export const useDeleteSuppliersId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSuppliersId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSuppliersId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSuppliersIdMutationOptions(options), queryClient)
}
export const getPatchSuppliersIdUrl = (id: number) => {
  return `/api/v1/suppliers/${id}`
}

/**
 * @summary Change a supplier
 */
export const patchSuppliersId = async (
  id: number,
  patchSuppliersIdBody?: PatchSuppliersIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Supplier> => {
  return customFetch<Supplier>(getPatchSuppliersIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchSuppliersIdBody),
  })
}

export const getPatchSuppliersIdMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSuppliersId>>,
    TError,
    { id: number; data?: PatchSuppliersIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSuppliersId>>,
  TError,
  { id: number; data?: PatchSuppliersIdBody },
  TContext
> => {
  const mutationKey = ['patchSuppliersId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSuppliersId>>,
    { id: number; data?: PatchSuppliersIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchSuppliersId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSuppliersIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSuppliersId>>
>
export type PatchSuppliersIdMutationBody = PatchSuppliersIdBody | undefined
export type PatchSuppliersIdMutationError = unknown

/**
 * @summary Change a supplier
 */
export const usePatchSuppliersId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSuppliersId>>,
      TError,
      { id: number; data?: PatchSuppliersIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSuppliersId>>,
  TError,
  { id: number; data?: PatchSuppliersIdBody },
  TContext
> => {
  return useMutation(getPatchSuppliersIdMutationOptions(options), queryClient)
}
export const getDeleteSupplierItemsIdUrl = (id: number) => {
  return `/api/v1/supplier-items/${id}`
}

/**
 * @summary Remove a mapping
 */
export const deleteSupplierItemsId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteSupplierItemsIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteSupplierItemsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSupplierItemsId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSupplierItemsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteSupplierItemsId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSupplierItemsId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteSupplierItemsId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSupplierItemsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSupplierItemsId>>
>

export type DeleteSupplierItemsIdMutationError = unknown

/**
 * @summary Remove a mapping
 */
export const useDeleteSupplierItemsId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSupplierItemsId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSupplierItemsId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSupplierItemsIdMutationOptions(options), queryClient)
}
export const getPatchSupplierItemsIdUrl = (id: number) => {
  return `/api/v1/supplier-items/${id}`
}

/**
 * @summary Change a mapping
 */
export const patchSupplierItemsId = async (
  id: number,
  patchSupplierItemsIdBody?: PatchSupplierItemsIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResolvedSupplierCode> => {
  return customFetch<ResolvedSupplierCode>(getPatchSupplierItemsIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchSupplierItemsIdBody),
  })
}

export const getPatchSupplierItemsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSupplierItemsId>>,
    TError,
    { id: number; data?: PatchSupplierItemsIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSupplierItemsId>>,
  TError,
  { id: number; data?: PatchSupplierItemsIdBody },
  TContext
> => {
  const mutationKey = ['patchSupplierItemsId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSupplierItemsId>>,
    { id: number; data?: PatchSupplierItemsIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchSupplierItemsId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSupplierItemsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSupplierItemsId>>
>
export type PatchSupplierItemsIdMutationBody = PatchSupplierItemsIdBody | undefined
export type PatchSupplierItemsIdMutationError = unknown

/**
 * @summary Change a mapping
 */
export const usePatchSupplierItemsId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSupplierItemsId>>,
      TError,
      { id: number; data?: PatchSupplierItemsIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSupplierItemsId>>,
  TError,
  { id: number; data?: PatchSupplierItemsIdBody },
  TContext
> => {
  return useMutation(getPatchSupplierItemsIdMutationOptions(options), queryClient)
}
export const getDeleteStockItemsIdUrl = (id: number) => {
  return `/api/v1/stock/items/${id}`
}

/**
 * @summary Remove a stock item
 */
export const deleteStockItemsId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteStockItemsIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteStockItemsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStockItemsId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStockItemsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteStockItemsId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStockItemsId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteStockItemsId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteStockItemsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStockItemsId>>
>

export type DeleteStockItemsIdMutationError = unknown

/**
 * @summary Remove a stock item
 */
export const useDeleteStockItemsId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteStockItemsId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteStockItemsId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteStockItemsIdMutationOptions(options), queryClient)
}
export const getPatchStockItemsIdUrl = (id: number) => {
  return `/api/v1/stock/items/${id}`
}

/**
 * @summary Change a stock item
 */
export const patchStockItemsId = async (
  id: number,
  stockItemRequest?: StockItemRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<StockItem> => {
  return customFetch<StockItem>(getPatchStockItemsIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stockItemRequest),
  })
}

export const getPatchStockItemsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchStockItemsId>>,
    TError,
    { id: number; data?: StockItemRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchStockItemsId>>,
  TError,
  { id: number; data?: StockItemRequest },
  TContext
> => {
  const mutationKey = ['patchStockItemsId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchStockItemsId>>,
    { id: number; data?: StockItemRequest }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchStockItemsId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchStockItemsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchStockItemsId>>
>
export type PatchStockItemsIdMutationBody = StockItemRequest | undefined
export type PatchStockItemsIdMutationError = unknown

/**
 * @summary Change a stock item
 */
export const usePatchStockItemsId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchStockItemsId>>,
      TError,
      { id: number; data?: StockItemRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchStockItemsId>>,
  TError,
  { id: number; data?: StockItemRequest },
  TContext
> => {
  return useMutation(getPatchStockItemsIdMutationOptions(options), queryClient)
}
export const getDeleteStockItemCategoriesIdUrl = (id: number) => {
  return `/api/v1/stock-item-categories/${id}`
}

/**
 * @summary Remove a stock category that nothing uses
 */
export const deleteStockItemCategoriesId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteStockItemCategoriesIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteStockItemCategoriesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStockItemCategoriesId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStockItemCategoriesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteStockItemCategoriesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStockItemCategoriesId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteStockItemCategoriesId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteStockItemCategoriesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStockItemCategoriesId>>
>

export type DeleteStockItemCategoriesIdMutationError = unknown

/**
 * @summary Remove a stock category that nothing uses
 */
export const useDeleteStockItemCategoriesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteStockItemCategoriesId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteStockItemCategoriesId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteStockItemCategoriesIdMutationOptions(options), queryClient)
}
export const getPatchStockItemCategoriesIdUrl = (id: number) => {
  return `/api/v1/stock-item-categories/${id}`
}

/**
 * @summary Rename or reorder a stock category
 */
export const patchStockItemCategoriesId = async (
  id: number,
  stockCategoryRequest: StockCategoryRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<StockCategory> => {
  return customFetch<StockCategory>(getPatchStockItemCategoriesIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stockCategoryRequest),
  })
}

export const getPatchStockItemCategoriesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchStockItemCategoriesId>>,
    TError,
    { id: number; data: StockCategoryRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchStockItemCategoriesId>>,
  TError,
  { id: number; data: StockCategoryRequest },
  TContext
> => {
  const mutationKey = ['patchStockItemCategoriesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchStockItemCategoriesId>>,
    { id: number; data: StockCategoryRequest }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchStockItemCategoriesId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchStockItemCategoriesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchStockItemCategoriesId>>
>
export type PatchStockItemCategoriesIdMutationBody = StockCategoryRequest
export type PatchStockItemCategoriesIdMutationError = unknown

/**
 * @summary Rename or reorder a stock category
 */
export const usePatchStockItemCategoriesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchStockItemCategoriesId>>,
      TError,
      { id: number; data: StockCategoryRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchStockItemCategoriesId>>,
  TError,
  { id: number; data: StockCategoryRequest },
  TContext
> => {
  return useMutation(getPatchStockItemCategoriesIdMutationOptions(options), queryClient)
}
export const getGetSuppliersSupplierIdResolveCodeCodeUrl = (supplierId: number, code: string) => {
  return `/api/v1/suppliers/${supplierId}/resolve-code/${code}`
}

/**
 * @summary What a code on an invoice maps to
 */
export const getSuppliersSupplierIdResolveCodeCode = async (
  supplierId: number,
  code: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResolvedSupplierCode> => {
  return customFetch<ResolvedSupplierCode>(
    getGetSuppliersSupplierIdResolveCodeCodeUrl(supplierId, code),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getGetSuppliersSupplierIdResolveCodeCodeQueryKey = (
  supplierId: number,
  code: string,
) => {
  return [`/api/v1/suppliers/${supplierId}/resolve-code/${code}`] as const
}

export const getGetSuppliersSupplierIdResolveCodeCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>,
  TError = unknown,
>(
  supplierId: number,
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetSuppliersSupplierIdResolveCodeCodeQueryKey(supplierId, code)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>
  > = ({ signal }) =>
    getSuppliersSupplierIdResolveCodeCode(supplierId, code, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: supplierId !== null && supplierId !== undefined && code !== null && code !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuppliersSupplierIdResolveCodeCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>
>
export type GetSuppliersSupplierIdResolveCodeCodeQueryError = unknown

export function useGetSuppliersSupplierIdResolveCodeCode<
  TData = Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>,
  TError = unknown,
>(
  supplierId: number,
  code: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>,
          TError,
          Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuppliersSupplierIdResolveCodeCode<
  TData = Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>,
  TError = unknown,
>(
  supplierId: number,
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>,
          TError,
          Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuppliersSupplierIdResolveCodeCode<
  TData = Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>,
  TError = unknown,
>(
  supplierId: number,
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What a code on an invoice maps to
 */

export function useGetSuppliersSupplierIdResolveCodeCode<
  TData = Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>,
  TError = unknown,
>(
  supplierId: number,
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersSupplierIdResolveCodeCode>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuppliersSupplierIdResolveCodeCodeQueryOptions(
    supplierId,
    code,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSupplierItemsIdPriceHistoryUrl = (id: number) => {
  return `/api/v1/supplier-items/${id}/price-history`
}

/**
 * @summary Every price ever paid for one mapping
 */
export const getSupplierItemsIdPriceHistory = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierPriceHistoryEntry[]> => {
  return customFetch<SupplierPriceHistoryEntry[]>(getGetSupplierItemsIdPriceHistoryUrl(id), {
    ...options,
    method: 'GET',
  })
}

export const getGetSupplierItemsIdPriceHistoryQueryKey = (id: number) => {
  return [`/api/v1/supplier-items/${id}/price-history`] as const
}

export const getGetSupplierItemsIdPriceHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSupplierItemsIdPriceHistoryQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>> = ({
    signal,
  }) => getSupplierItemsIdPriceHistory(id, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupplierItemsIdPriceHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>
>
export type GetSupplierItemsIdPriceHistoryQueryError = unknown

export function useGetSupplierItemsIdPriceHistory<
  TData = Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>,
          TError,
          Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupplierItemsIdPriceHistory<
  TData = Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>,
          TError,
          Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupplierItemsIdPriceHistory<
  TData = Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every price ever paid for one mapping
 */

export function useGetSupplierItemsIdPriceHistory<
  TData = Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplierItemsIdPriceHistory>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSupplierItemsIdPriceHistoryQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSupplierComparisonStockItemIdUrl = (stockItemId: number) => {
  return `/api/v1/supplier-comparison/${stockItemId}`
}

/**
 * @summary The same item from every supplier who sells it
 */
export const getSupplierComparisonStockItemId = async (
  stockItemId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierComparison[]> => {
  return customFetch<SupplierComparison[]>(getGetSupplierComparisonStockItemIdUrl(stockItemId), {
    ...options,
    method: 'GET',
  })
}

export const getGetSupplierComparisonStockItemIdQueryKey = (stockItemId: number) => {
  return [`/api/v1/supplier-comparison/${stockItemId}`] as const
}

export const getGetSupplierComparisonStockItemIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>,
  TError = unknown,
>(
  stockItemId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetSupplierComparisonStockItemIdQueryKey(stockItemId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>> = ({
    signal,
  }) => getSupplierComparisonStockItemId(stockItemId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: stockItemId !== null && stockItemId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupplierComparisonStockItemIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>
>
export type GetSupplierComparisonStockItemIdQueryError = unknown

export function useGetSupplierComparisonStockItemId<
  TData = Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>,
  TError = unknown,
>(
  stockItemId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>,
          TError,
          Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupplierComparisonStockItemId<
  TData = Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>,
  TError = unknown,
>(
  stockItemId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>,
          TError,
          Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupplierComparisonStockItemId<
  TData = Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>,
  TError = unknown,
>(
  stockItemId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The same item from every supplier who sells it
 */

export function useGetSupplierComparisonStockItemId<
  TData = Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>,
  TError = unknown,
>(
  stockItemId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupplierComparisonStockItemId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSupplierComparisonStockItemIdQueryOptions(stockItemId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetStockMarginsUrl = () => {
  return `/api/v1/stock/margins`
}

/**
 * @summary What each dish costs against what it sells for
 */
export const getStockMargins = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<StockMargin[]> => {
  return customFetch<StockMargin[]>(getGetStockMarginsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetStockMarginsQueryKey = () => {
  return [`/api/v1/stock/margins`] as const
}

export const getGetStockMarginsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockMargins>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockMargins>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetStockMarginsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockMargins>>> = ({ signal }) =>
    getStockMargins({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockMargins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStockMarginsQueryResult = NonNullable<Awaited<ReturnType<typeof getStockMargins>>>
export type GetStockMarginsQueryError = unknown

export function useGetStockMargins<
  TData = Awaited<ReturnType<typeof getStockMargins>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockMargins>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockMargins>>,
          TError,
          Awaited<ReturnType<typeof getStockMargins>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockMargins<
  TData = Awaited<ReturnType<typeof getStockMargins>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockMargins>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockMargins>>,
          TError,
          Awaited<ReturnType<typeof getStockMargins>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockMargins<
  TData = Awaited<ReturnType<typeof getStockMargins>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockMargins>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What each dish costs against what it sells for
 */

export function useGetStockMargins<
  TData = Awaited<ReturnType<typeof getStockMargins>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockMargins>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStockMarginsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetStockCategoriesUrl = () => {
  return `/api/v1/stock/categories`
}

/**
 * @summary The categories in use
 */
export const getStockCategories = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<string[]> => {
  return customFetch<string[]>(getGetStockCategoriesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetStockCategoriesQueryKey = () => {
  return [`/api/v1/stock/categories`] as const
}

export const getGetStockCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockCategories>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockCategories>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetStockCategoriesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockCategories>>> = ({ signal }) =>
    getStockCategories({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStockCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockCategories>>
>
export type GetStockCategoriesQueryError = unknown

export function useGetStockCategories<
  TData = Awaited<ReturnType<typeof getStockCategories>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockCategories>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockCategories>>,
          TError,
          Awaited<ReturnType<typeof getStockCategories>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockCategories<
  TData = Awaited<ReturnType<typeof getStockCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockCategories>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockCategories>>,
          TError,
          Awaited<ReturnType<typeof getStockCategories>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockCategories<
  TData = Awaited<ReturnType<typeof getStockCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockCategories>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The categories in use
 */

export function useGetStockCategories<
  TData = Awaited<ReturnType<typeof getStockCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockCategories>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStockCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetReorderDraftsUrl = (params?: GetReorderDraftsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/reorder-drafts?${stringifiedParams}`
    : `/api/v1/reorder-drafts`
}

/**
 * @summary The drafts
 */
export const getReorderDrafts = async (
  params?: GetReorderDraftsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReorderDraftSummary[]> => {
  return customFetch<ReorderDraftSummary[]>(getGetReorderDraftsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetReorderDraftsQueryKey = (params?: GetReorderDraftsParams) => {
  return [`/api/v1/reorder-drafts`, ...(params ? [params] : [])] as const
}

export const getGetReorderDraftsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReorderDrafts>>,
  TError = unknown,
>(
  params?: GetReorderDraftsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReorderDrafts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetReorderDraftsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReorderDrafts>>> = ({ signal }) =>
    getReorderDrafts(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReorderDrafts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReorderDraftsQueryResult = NonNullable<Awaited<ReturnType<typeof getReorderDrafts>>>
export type GetReorderDraftsQueryError = unknown

export function useGetReorderDrafts<
  TData = Awaited<ReturnType<typeof getReorderDrafts>>,
  TError = unknown,
>(
  params: undefined | GetReorderDraftsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReorderDrafts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReorderDrafts>>,
          TError,
          Awaited<ReturnType<typeof getReorderDrafts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReorderDrafts<
  TData = Awaited<ReturnType<typeof getReorderDrafts>>,
  TError = unknown,
>(
  params?: GetReorderDraftsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReorderDrafts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReorderDrafts>>,
          TError,
          Awaited<ReturnType<typeof getReorderDrafts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReorderDrafts<
  TData = Awaited<ReturnType<typeof getReorderDrafts>>,
  TError = unknown,
>(
  params?: GetReorderDraftsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReorderDrafts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The drafts
 */

export function useGetReorderDrafts<
  TData = Awaited<ReturnType<typeof getReorderDrafts>>,
  TError = unknown,
>(
  params?: GetReorderDraftsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReorderDrafts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReorderDraftsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetReorderDraftsIdUrl = (id: number) => {
  return `/api/v1/reorder-drafts/${id}`
}

/**
 * @summary One draft, with its lines
 */
export const getReorderDraftsId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReorderDraft> => {
  return customFetch<ReorderDraft>(getGetReorderDraftsIdUrl(id), {
    ...options,
    method: 'GET',
  })
}

export const getGetReorderDraftsIdQueryKey = (id: number) => {
  return [`/api/v1/reorder-drafts/${id}`] as const
}

export const getGetReorderDraftsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getReorderDraftsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReorderDraftsId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetReorderDraftsIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReorderDraftsId>>> = ({ signal }) =>
    getReorderDraftsId(id, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getReorderDraftsId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetReorderDraftsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReorderDraftsId>>
>
export type GetReorderDraftsIdQueryError = unknown

export function useGetReorderDraftsId<
  TData = Awaited<ReturnType<typeof getReorderDraftsId>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReorderDraftsId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReorderDraftsId>>,
          TError,
          Awaited<ReturnType<typeof getReorderDraftsId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReorderDraftsId<
  TData = Awaited<ReturnType<typeof getReorderDraftsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReorderDraftsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReorderDraftsId>>,
          TError,
          Awaited<ReturnType<typeof getReorderDraftsId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReorderDraftsId<
  TData = Awaited<ReturnType<typeof getReorderDraftsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReorderDraftsId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One draft, with its lines
 */

export function useGetReorderDraftsId<
  TData = Awaited<ReturnType<typeof getReorderDraftsId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReorderDraftsId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReorderDraftsIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getDeleteReorderDraftsIdUrl = (id: number) => {
  return `/api/v1/reorder-drafts/${id}`
}

/**
 * @summary Discard a draft
 */
export const deleteReorderDraftsId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteReorderDraftsIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteReorderDraftsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReorderDraftsId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReorderDraftsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteReorderDraftsId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReorderDraftsId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteReorderDraftsId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteReorderDraftsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReorderDraftsId>>
>

export type DeleteReorderDraftsIdMutationError = unknown

/**
 * @summary Discard a draft
 */
export const useDeleteReorderDraftsId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteReorderDraftsId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteReorderDraftsId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteReorderDraftsIdMutationOptions(options), queryClient)
}
export const getGetBeverageStockSummaryUrl = (params?: GetBeverageStockSummaryParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/beverage-stock/summary?${stringifiedParams}`
    : `/api/v1/beverage-stock/summary`
}

/**
 * @summary Drinks in, drinks out, drinks left
 */
export const getBeverageStockSummary = async (
  params?: GetBeverageStockSummaryParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<BeverageStockSummary> => {
  return customFetch<BeverageStockSummary>(getGetBeverageStockSummaryUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetBeverageStockSummaryQueryKey = (params?: GetBeverageStockSummaryParams) => {
  return [`/api/v1/beverage-stock/summary`, ...(params ? [params] : [])] as const
}

export const getGetBeverageStockSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getBeverageStockSummary>>,
  TError = unknown,
>(
  params?: GetBeverageStockSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockSummary>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetBeverageStockSummaryQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBeverageStockSummary>>> = ({
    signal,
  }) => getBeverageStockSummary(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBeverageStockSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBeverageStockSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBeverageStockSummary>>
>
export type GetBeverageStockSummaryQueryError = unknown

export function useGetBeverageStockSummary<
  TData = Awaited<ReturnType<typeof getBeverageStockSummary>>,
  TError = unknown,
>(
  params: undefined | GetBeverageStockSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockSummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBeverageStockSummary>>,
          TError,
          Awaited<ReturnType<typeof getBeverageStockSummary>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBeverageStockSummary<
  TData = Awaited<ReturnType<typeof getBeverageStockSummary>>,
  TError = unknown,
>(
  params?: GetBeverageStockSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockSummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBeverageStockSummary>>,
          TError,
          Awaited<ReturnType<typeof getBeverageStockSummary>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBeverageStockSummary<
  TData = Awaited<ReturnType<typeof getBeverageStockSummary>>,
  TError = unknown,
>(
  params?: GetBeverageStockSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockSummary>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Drinks in, drinks out, drinks left
 */

export function useGetBeverageStockSummary<
  TData = Awaited<ReturnType<typeof getBeverageStockSummary>>,
  TError = unknown,
>(
  params?: GetBeverageStockSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockSummary>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetBeverageStockSummaryQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetBeverageStockProductsUrl = () => {
  return `/api/v1/beverage-stock/products`
}

/**
 * @summary The products the bar can receive
 */
export const getBeverageStockProducts = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BeverageProduct[]> => {
  return customFetch<BeverageProduct[]>(getGetBeverageStockProductsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetBeverageStockProductsQueryKey = () => {
  return [`/api/v1/beverage-stock/products`] as const
}

export const getGetBeverageStockProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBeverageStockProducts>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockProducts>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetBeverageStockProductsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBeverageStockProducts>>> = ({
    signal,
  }) => getBeverageStockProducts({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBeverageStockProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBeverageStockProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBeverageStockProducts>>
>
export type GetBeverageStockProductsQueryError = unknown

export function useGetBeverageStockProducts<
  TData = Awaited<ReturnType<typeof getBeverageStockProducts>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockProducts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBeverageStockProducts>>,
          TError,
          Awaited<ReturnType<typeof getBeverageStockProducts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBeverageStockProducts<
  TData = Awaited<ReturnType<typeof getBeverageStockProducts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockProducts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBeverageStockProducts>>,
          TError,
          Awaited<ReturnType<typeof getBeverageStockProducts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBeverageStockProducts<
  TData = Awaited<ReturnType<typeof getBeverageStockProducts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockProducts>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The products the bar can receive
 */

export function useGetBeverageStockProducts<
  TData = Awaited<ReturnType<typeof getBeverageStockProducts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockProducts>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetBeverageStockProductsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetBeverageStockItemsUrl = () => {
  return `/api/v1/beverage-stock/items`
}

/**
 * @summary The drinks the bar's stock take counts
 */
export const getBeverageStockItems = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BeverageStockItem[]> => {
  return customFetch<BeverageStockItem[]>(getGetBeverageStockItemsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetBeverageStockItemsQueryKey = () => {
  return [`/api/v1/beverage-stock/items`] as const
}

export const getGetBeverageStockItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBeverageStockItems>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockItems>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetBeverageStockItemsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBeverageStockItems>>> = ({ signal }) =>
    getBeverageStockItems({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBeverageStockItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBeverageStockItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBeverageStockItems>>
>
export type GetBeverageStockItemsQueryError = unknown

export function useGetBeverageStockItems<
  TData = Awaited<ReturnType<typeof getBeverageStockItems>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockItems>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBeverageStockItems>>,
          TError,
          Awaited<ReturnType<typeof getBeverageStockItems>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBeverageStockItems<
  TData = Awaited<ReturnType<typeof getBeverageStockItems>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockItems>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBeverageStockItems>>,
          TError,
          Awaited<ReturnType<typeof getBeverageStockItems>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBeverageStockItems<
  TData = Awaited<ReturnType<typeof getBeverageStockItems>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockItems>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The drinks the bar's stock take counts
 */

export function useGetBeverageStockItems<
  TData = Awaited<ReturnType<typeof getBeverageStockItems>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockItems>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetBeverageStockItemsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetBeverageStockCategoriesUrl = () => {
  return `/api/v1/beverage-stock/categories`
}

/**
 * @summary The bar's categories, and what decides whether each counts
 */
export const getBeverageStockCategories = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BeverageCategories> => {
  return customFetch<BeverageCategories>(getGetBeverageStockCategoriesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetBeverageStockCategoriesQueryKey = () => {
  return [`/api/v1/beverage-stock/categories`] as const
}

export const getGetBeverageStockCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getBeverageStockCategories>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockCategories>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetBeverageStockCategoriesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBeverageStockCategories>>> = ({
    signal,
  }) => getBeverageStockCategories({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBeverageStockCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBeverageStockCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBeverageStockCategories>>
>
export type GetBeverageStockCategoriesQueryError = unknown

export function useGetBeverageStockCategories<
  TData = Awaited<ReturnType<typeof getBeverageStockCategories>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockCategories>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBeverageStockCategories>>,
          TError,
          Awaited<ReturnType<typeof getBeverageStockCategories>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBeverageStockCategories<
  TData = Awaited<ReturnType<typeof getBeverageStockCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockCategories>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBeverageStockCategories>>,
          TError,
          Awaited<ReturnType<typeof getBeverageStockCategories>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBeverageStockCategories<
  TData = Awaited<ReturnType<typeof getBeverageStockCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockCategories>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The bar's categories, and what decides whether each counts
 */

export function useGetBeverageStockCategories<
  TData = Awaited<ReturnType<typeof getBeverageStockCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBeverageStockCategories>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetBeverageStockCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
